import { FREE_FORM_LAYOUT_ID, freeFormLayout } from './freeform';
import { LAYOUT_DIRECTIONS, LAYOUT_FAMILIES, layoutId, } from '@orbit-mind/shared-types';
import { fishboneLayout } from './fishbone';
import { LIST_FAMILIES, listLayout } from './list';
import { metroLayout } from './metro';
import { radialLayout } from './radial';
import { boardLayout, layersLayout, matrixLayout, roadLayout, timelineLayout } from './structures';
import { treeLayout } from './tree';
/**
 * The families that are trees: one packing, and a different drawing each — curved, straight,
 * cornered or continuous links, and for the `simple-` ones text on a line instead of a box.
 */
const TREE_FAMILIES = [
    'curved-line-tree',
    'direct-line-tree',
    'cornered-tree',
    'simple-tree-curved',
    'simple-tree-direct',
    'simple-tree-cornered',
    'continuous-tree',
];
const REGISTERED = new Map([
    [FREE_FORM_LAYOUT_ID, freeFormLayout],
    [radialLayout.id, radialLayout],
    [fishboneLayout.id, fishboneLayout],
    // The structures: diagrams of their own, each for the whole map.
    [metroLayout.id, metroLayout],
    [timelineLayout.id, timelineLayout],
    [matrixLayout.id, matrixLayout],
    [boardLayout.id, boardLayout],
    [roadLayout.id, roadLayout],
    [layersLayout.id, layersLayout],
]);
// Every tree and every list, in all six directions: the whole catalogue `shared-types` names.
for (const family of TREE_FAMILIES) {
    for (const direction of LAYOUT_DIRECTIONS) {
        const id = layoutId(family, direction);
        REGISTERED.set(id, treeLayout(id, `${LAYOUT_FAMILIES[family].label}, ${direction}`));
    }
}
for (const family of LIST_FAMILIES) {
    for (const direction of LAYOUT_DIRECTIONS) {
        const id = layoutId(family, direction);
        REGISTERED.set(id, listLayout(id, `${LAYOUT_FAMILIES[family].label}, ${direction}`));
    }
}
/** Every layout this build can run. */
export function layouts() {
    return [...REGISTERED.values()];
}
export function isKnownLayout(layoutId) {
    return REGISTERED.has(layoutId);
}
/**
 * The algorithm for a layout id, or free-form.
 *
 * The fallback is deliberate and is not a silent failure: a map arranged by a layout this build
 * does not have still opens, still renders at the coordinates it was saved with, and can still
 * be edited. Refusing would strand the document; rearranging it with a substitute algorithm would
 * destroy an arrangement the user cannot get back.
 */
export function layoutFor(layoutId) {
    return REGISTERED.get(layoutId) ?? freeFormLayout;
}
/**
 * Adds an algorithm.
 *
 * Exported for the steps that follow, and for a test that wants a stub. Replacing a registered id
 * is allowed: a build shipping a better packing for an existing layout should not have to
 * invent a new id for it, because the id is what a saved document refers to.
 */
export function registerLayout(algorithm) {
    REGISTERED.set(algorithm.id, algorithm);
}
//# sourceMappingURL=registry.js.map